export class RoleNames {
  public static foreignDataView = 'foreign-data-view';
  public static foreignDataManage = 'foreign-data-manage';
  public static timeSheetView = 'time-sheet-view';
  public static timeSheetManage = 'time-sheet-manage';
  public static chartsByCustomerView = 'charts-by-customer-view';
  public static chartsByOrderView = 'charts-by-order-view';
  public static chartsByProjectView = 'charts-by-project-view';
  public static chartsByActivityView = 'charts-by-activity-view';
  public static chartsByIssueView = 'charts-by-issue-view';
  public static reportActivitySummaryView = 'report-activity-summary-view';
  public static reportActivityDetailView = 'report-activity-detail-view';
  public static reportActivityRawDataView = 'report-activity-raw-data-view';
  public static masterDataCustomersView = 'master-data-customers-view';
  public static masterDataCustomersManage = 'master-data-customers-manage';
  public static masterDataProjectsView = 'master-data-projects-view';
  public static masterDataProjectsManage = 'master-data-projects-manage';
  public static masterDataActivitiesView = 'master-data-activities-view';
  public static masterDataActivitiesManage = 'master-data-activities-manage';
  public static masterDataOrdersView = 'master-data-orders-view';
  public static masterDataOrdersManage = 'master-data-orders-manage';
  public static masterDataHolidaysView = 'master-data-holidays-view';
  public static masterDataHolidaysManage = 'master-data-holidays-manage';
  public static administrationUsersView = 'administration-users-view';
  public static administrationUsersManage = 'administration-users-manage';
  public static administrationSettingsView = 'administration-settings-view';
  public static administrationSettingsManage = 'administration-settings-manage';
}
